import { useCallback } from 'react';
import { useRequest } from 'ahooks';
import { Options } from 'ahooks/lib/useRequest/src/types';
import { AxiosResponse } from 'axios';

import { apiPatch } from 'api';

import { useGetHeaders } from 'hooks';

import {
  IApiHookRequestParams,
  IApiRequestParams,
  TRequestCallback,
  TResponse,
} from 'types';

import { handleRequest } from './handleRequest';

export const usePatchRequest = <R, P = undefined>(opts?: IApiHookRequestParams<R, IApiRequestParams<P>>): [
  request: TRequestCallback<P>,
  response: TResponse<R, IApiRequestParams<P>>
] => {
  const {
    url,
    options,
    baseURL,
    queryParams,
  } = opts || {};

  const {
    run,
    data,
    ...rest
  } = useRequest<AxiosResponse<R, P>, [IApiRequestParams<P>]>(
    apiPatch,
    { ...options, manual: true } as Options<AxiosResponse<R>, [IApiRequestParams<P>]>,
  );

  const headers = useGetHeaders();

  const handlePatchRequest = useCallback(handleRequest({
    run,
    url,
    baseURL,
    headers,
    queryParams,
  }), [url, headers]);

  return [
    handlePatchRequest,
    {
      ...rest,
      data: data?.data,
    } as TResponse<R, IApiRequestParams<P>>,
  ];
};
